"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicWidgets = void 0;
var tslib_1 = require("tslib");
var public_catalog_service_1 = require("../../../catalog-services/public-catalog-service");
var PublicWidgets = /** @class */ (function (_super) {
    tslib_1.__extends(PublicWidgets, _super);
    function PublicWidgets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicWidgets.prototype.buildQueryString = function (config) {
        var params = [];
        for (var key in config) {
            if (config[key]) {
                params.push("".concat(key, "=").concat(config[key]));
            }
        }
        return params.join('&');
    };
    PublicWidgets.prototype.buildDeeplinksUrl = function (config) {
        var host = config.host, channelId = config.channelId, videoId = config.videoId, instance = config.instance, fallbackUrl = config.fallbackUrl;
        var params = {
            fallback_url: fallbackUrl,
            list_id: channelId,
            item_id: videoId,
            instance: instance,
        };
        var queryString = this.buildQueryString(params);
        return "".concat(host, "/public/widgets/deeplinks/active/redirect?").concat(queryString);
    };
    PublicWidgets.prototype.getSettings = function (widgetId, requestConfig) {
        return this.get("/public/widgets/".concat(widgetId, "/settings"), requestConfig);
    };
    PublicWidgets.prototype.getSettingsByInstanceId = function (instanceId, requestConfig) {
        return this.get("/public/widgets?instance_id=".concat(instanceId), requestConfig);
    };
    PublicWidgets.prototype.getChannelDeepLinks = function (channelId, requestConfig) {
        return this.get("/public/widgets/deeplinks?list_id=".concat(channelId), requestConfig);
    };
    PublicWidgets.prototype.buildVideoCardsDeeplinkUrl = function (config) {
        return this.buildDeeplinksUrl(config);
    };
    PublicWidgets.prototype.buildChannelCardsDeeplinkUrl = function (config) {
        return this.buildDeeplinksUrl(config);
    };
    return PublicWidgets;
}(public_catalog_service_1.PublicCatalogService));
exports.PublicWidgets = PublicWidgets;
//# sourceMappingURL=widgets.js.map